import { MonitoringEntity } from 'routes/Dashboard/Monitoring/enums';

export default function getFilterFieldNameByMonitoringEntity(
  monitoringEntity: MonitoringEntity,
  name: string,
) {
  return `${monitoringEntity}-${name}`;
}
